var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompleted = function SvgCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40 64c13.255 0 24-10.745 24-24 0-2.874-.505-5.63-1.432-8.184l-24.75 24.75-15.92-15.92 5.657-5.656 10.263 10.262 20.619-20.618C54.034 19.357 47.409 16 40 16c-13.255 0-24 10.745-24 24s10.745 24 24 24"
  })));
};
export default SvgCompleted;